import React from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { ColorPath, ThemeType } from 'types/Theme';
import { cssTheme } from '../../../themes';
import { getCssColorByPath } from '../../../utils/colors';
interface Props {
  /** Card content */
  children?: React.ReactNode;
  /** Pass through classname to allow styles overrides */
  className?: string;
  /** Whether card should have rounded corners at the top */
  hasRoundedTop?: boolean;
  /** Whether card should have rounded corners at the bottom */
  hasRoundedBottom?: boolean;
  /** Radius of rounded corners */
  borderRadius?: keyof ThemeType['layout']['radius'];
  /** Shows up 1px border with specified color */
  borderColorPath?: ColorPath;
  /** Sets background color of Card component */
  backgroundColorPath?: ColorPath;
  /** Whether card should have shadow */
  shadow?: keyof ThemeType['shadows'];
  /** Whether overflowing content of the card should be hidden */
  isOverflowHidden?: boolean;
  /** Identify the element for selection in integration tests, FullStory, etc. */
  dataId?: string;
  /** Style prop is used by Linaria to pass CSS variables in cases when we need to style custom components in this way: `const StyledCard = styled(Card)` */
  style?: React.CSSProperties;
}
interface StyledCardProps extends Props {
  backgroundColorValue?: string;
  borderColorValue?: string;
}
const _exp = /*#__PURE__*/() => ({
  backgroundColorValue
}) => backgroundColorValue ?? cssTheme.colors.background.neutral.c000;
const _exp2 = /*#__PURE__*/() => ({
  isOverflowHidden
}) => isOverflowHidden ? 'hidden' : 'visible';
const _exp3 = /*#__PURE__*/() => ({
  borderColorValue
}) => borderColorValue ? `1px solid ${borderColorValue}` : 'none';
const _exp4 = /*#__PURE__*/() => ({
  shadow
}) => shadow && shadow !== 'flat' ? cssTheme.shadows[shadow] : 'none';
const _exp8 = /*#__PURE__*/() => ({
  borderRadius
}) => borderRadius ? cssTheme.layout.radius[borderRadius] : 0;
const CardElement = /*#__PURE__*/styled('div')({
  name: "CardElement",
  class: "c1fitgy2",
  propsAsIs: false,
  vars: {
    "c1fitgy2-0": [_exp()],
    "c1fitgy2-1": [_exp2()],
    "c1fitgy2-2": [_exp3()],
    "c1fitgy2-3": [_exp4()],
    "c1fitgy2-4": [_exp8()]
  }
});
export const Card = ({
  children,
  dataId,
  hasRoundedTop = true,
  hasRoundedBottom = true,
  borderRadius,
  borderColorPath,
  backgroundColorPath,
  shadow,
  isOverflowHidden = true,
  className,
  style
}: Props) => {
  const borderColorValue = borderColorPath && getCssColorByPath(borderColorPath);
  const backgroundColorValue = backgroundColorPath && getCssColorByPath(backgroundColorPath);
  return <CardElement data-id={dataId} className={cx(className, hasRoundedTop && 'hasRoundedTop', hasRoundedBottom && 'hasRoundedBottom')} borderRadius={borderRadius} borderColorValue={borderColorValue} backgroundColorValue={backgroundColorValue} isOverflowHidden={isOverflowHidden} shadow={shadow} style={style}>
      {children}
    </CardElement>;
};

require("./Card.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Card.tsx");